import { chakra, Text } from "@chakra-ui/react";
import * as React from "react";
import { FieldError } from "react-hook-form";

type FieldWrapperProps = {
  label?: string;
  className?: string;
  children: React.ReactNode;
  error?: Partial<FieldError> | undefined;
  description?: string;
};

export type FieldWrapperPassThroughProps = Omit<
  FieldWrapperProps,
  "className" | "children"
>;

export const FieldWrapper = ({ label, error, children }: FieldWrapperProps) => {
  return (
    <div>
      <chakra.label
        fontSize="16px"
        lineHeight="18px"
        borderRadius="4px"
        display="flex"
        bg="white"
        justifyContent="center"
        alignItems="center"
        border={error ? "1px" : "0"}
        borderColor="red.300"
        h="40px"
      >
        {label}
        {children}
      </chakra.label>
      {error?.message && (
        <Text
          role="alert"
          aria-label={error.message}
          color="red.300"
          fontSize="xs"
        >
          {error.message}
        </Text>
      )}
    </div>
  );
};
